import React from 'react';
import useDigicertBadge from '../../hooks/useDigicertBadge';

const CertificationSeals = (): React.ReactElement => {
    useDigicertBadge();
    return (
        <div className="certification-seals flex w-full justify-center pb-24 space-x-2">
            <div className="digicert-container">
                {/* DigiCert Badge does not work in development mode */}
                <div id="DigiCertClickID_CBu92egn" data-language="en">
                    {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                    <a href="https://www.digicert.com/wildcard-ssl-certificates/"></a>
                </div>
            </div>
            <div className="trustwave-container">
                {/* eslint-disable jsx-a11y/click-events-have-key-events */}
                {/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */}
                <img
                    id="trustwaveSealImage"
                    src="https://sealserver.trustwave.com/seal_image.php?customerId=1e1d2f91c73b4c3f89d7630dcd78a281&size=105x54&style=invert"
                    style={{ cursor: 'pointer' }}
                    onClick={() => { window.open('https://sealserver.trustwave.com/cert.php?customerId=1e1d2f91c73b4c3f89d7630dcd78a281&size=105x54&style=invert', 'c_TW', 'location=no, toolbar=no, resizable=yes, scrollbars=yes, directories=no, status=no, width=615, height=720'); return false; }}
                    onContextMenu={() => { alert('Copying Prohibited by Law - Trusted Commerce is a Service Mark of TrustWave Holdings, Inc.'); return false; }}
                    alt="This site is protected by Trustwave's Trusted Commerce program"
                    title="This site is protected by Trustwave's Trusted Commerce program" />
                {/* eslint-enable jsx-a11y/click-events-have-key-events */}
                {/* eslint-enable jsx-a11y/no-noninteractive-element-interactions */}
            </div>
            <div className="bbb-container">
                <a href="http://www.bbb.org/wisconsin/business-reviews/insurance-travel/berkshire-hathaway-travel-protection-in-stevens-point-wi-1000025944/#sealclick" id="bbblink" className="ruhzbus" target="_blank" rel="nofollow noreferrer noopener">
                    <img src="https://seal-wisconsin.bbb.org/logo/ruhzbus/bbb-1000025944.png" style={{ border: 0 }} alt="BBB travel insurance review" />
                </a>
            </div>
            <div className="ustia-container">
                <a href="https://www.ustia.org/" target="blank">
                    <span id="ustia" role="img" aria-label="US Travel Insurance Association (UStiA)" />
                </a>
            </div>
        </div>
    );
};

export default CertificationSeals;
